// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".4492f92e034ea0c929642d8fb2ea42ad52c246c4.chunk.js";
};